import { filter } from 'lodash';
import { mapState } from 'vuex';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    title: String,
    type: {
      default: 'video',
      type: String
    },
    data: {
      default() {
        return [];
      },
      type: Array
    },
    deviceSelectId: {
      default: '',
      type: String
    },
    isHost: {
      type: Boolean,
      default: false
    },
    rtilCode: {
      type: [Number, String],
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    deviceState: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  data() {
    return {
      audiSettingInfo: {
        title: 'common.audioAdvancedSettings',
        show: false,
        cancel: 'start.cancel'
      },
      deviceId: '',
      openSelect: false
    };
  },
  created() {
    this.deviceId = this.deviceSelectId;
    this.audiSettingInfo.save = this.$route.name == 'preview' ? 'Movepips.save' : 'common.refreshSave';
  },
  watch: {
    deviceSelectId(val) {
      // this.handleDefault()
      this.deviceId = this.deviceSelectId;
      console.log('deviceId:', this.deviceSelectId);
    }
  },
  methods: {
    changeDeviceId(id) {
      this.deviceId = id;
    },
    visibleChange(flag) {
      this.openSelect = flag;
    },
    handleDefault() {
      if (this.data.length > 0) {
        if (this.type === 'video') {
          const defaultId = handleLocalStorage('get', 'cameraId');
          if (defaultId && filter(this.data, {
            deviceId: defaultId
          }).length > 0) {
            this.deviceId = defaultId;
            if (this.data.length > 1) {
              this.handleAudioOrVideo();
            }
          } else {
            this.deviceId = this.data[0].deviceId;
          }
        } else {
          const temp = filter(this.data, {
            deviceId: 'default'
          });
          const defaultId = this.type == 'audio' ? handleLocalStorage('get', 'microphoneId') : handleLocalStorage('get', 'speakerId');
          if (defaultId && filter(this.data, {
            deviceId: defaultId
          }).length > 0) {
            this.deviceId = defaultId;
            if (this.data.length > 1) {
              this.handleAudioOrVideo();
            }
          } else {
            this.deviceId = temp.length > 0 ? 'default' : this.data[0].deviceId;
          }
        }
      }
    },
    handleAudioOrVideo() {
      if (this.type == 'audio' || this.type == 'speaker') {
        this.$emit('updateDeviceId', this.type, this.deviceId);
      }
      this.$emit('changeDevice', {
        type: this.type,
        deviceId: this.deviceId,
        rtilCode: this.rtilCode
      });
    },
    showAudioSetting() {
      this.audiSettingInfo.show = true;
      this.$refs.deviceSelects.blur();
    }
  }
};